<template>
    <div :class="{'hidden':hidden}" class="pagination_container">
        <el-pagination
            background
            :current-page.sync="currentPage"
            :page-size.sync="pageSize"
            :pager-count="5"
            layout="total, prev, pager, next, jumper"
            :page-sizes="[12, 18, 24, 30]"
            :total="total"
            v-bind="$attrs"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
        />
    </div>
</template>

<script>
/**
 * ComponentName: 分页组件
 * Created Date:2022/5/9
 * Author: zenan·yu
 * Modify: 
 * 组件说明：
 * eg:
 *     <cl-pagination></cl-pagination>
 */
import { scrollTo } from '@/util/scroll-to'

export default {
    name: 'cl-pagination',
    props: {
        // 数据总条数
        total: {
            required: true,
            type: Number
        },
        // 当前页
        page: {
            type: Number,
            default: 1
        },
        // 每页个数
        limit: {
            type: Number,
            default: 12
        },
        // 是否跳转浏览器顶部
        autoScroll: {
            type: Boolean,
            default: true
        },
        // 是否隐藏分页
        hidden: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        currentPage: {
            get() {
                return this.page
            },
            set(val) {
                this.$emit('update:page', val)
            }
        },
        pageSize: {
            get() {
                return this.limit
            },
            set(val) {
                this.$emit('update:limit', val)
            }
        }
    },
    methods: {
        handleSizeChange(val) {
            this.$emit('pagination', { page_index: this.currentPage, page_size: val })
            if (this.autoScroll) {
                scrollTo(0, 800)
            }
        },
        handleCurrentChange(val) {
            this.$emit('pagination', { page_index: val, page_size: this.pageSize })
            if (this.autoScroll) {
                scrollTo(0, 800)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.pagination_container {
    height: 72px;
    background: #fff;
    border-radius: 0px 0px 6px 6px;
    border-top: 1px solid #E7EAF1;
    display: flex;
    align-items: center;
    justify-content: center;
}
.pagination_container.hidden {
  display: none;
}
</style>
